let inject = ['$scope', '$uibModalInstance'];

class OfflineModalController {
  constructor ($scope,$uibModalInstance) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.user = {};
  }
  
  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
  
  selectThird() {
    this.$uibModalInstance.close(this.user);
  }
}

OfflineModalController.$inject = inject;

export default OfflineModalController ;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/offline-modal/offline-modal.controller.js
 **/